import type { Midia } from '@/shared/types';

/** Campanha da plataforma no formato de Midia; reaproveita agendamento, cache e exibição. */
export type MidiaCampanha = Midia & { campanha_id: string };

export interface CampanhaPlayerRow {
  campanha_id: string;
  tipo: 'imagem' | 'video';
  url: string;
  duracao_segundos: number;
  data_inicio: string;
  data_fim: string;
}

/** id prefixado impede colisão com uma mídia cadastrada pelo bar. */
export function campanhaParaMidia(row: CampanhaPlayerRow, telaId: string): MidiaCampanha {
  return {
    id: `campanha:${row.campanha_id}`,
    campanha_id: row.campanha_id,
    empresa_id: '',
    tela_id: telaId,
    tipo: row.tipo,
    url: row.url,
    duracao_segundos: row.duracao_segundos,
    ordem: 0,
    titulo: null,
    preco: null,
    data_inicio: row.data_inicio,
    data_fim: row.data_fim,
    hora_inicio: null,
    hora_fim: null,
    dias_semana: null,
    created_at: '',
  };
}

export function ehCampanha(midia: Midia | null | undefined): midia is MidiaCampanha {
  return !!midia && typeof (midia as Partial<MidiaCampanha>).campanha_id === 'string';
}

/** Insere campanhas da plataforma proporcionalmente ao percentual reservado. */
export function intercalarCampanhas(proprias: Midia[], campanhas: MidiaCampanha[], reservaPct: number, volta: number): Midia[] {
  if (proprias.length === 0) return [];
  if (reservaPct <= 0 || campanhas.length === 0) return proprias;

  const inicio = ((volta % campanhas.length) + campanhas.length) % campanhas.length;
  const campanhaDaRodada = (indice: number) => campanhas[(inicio + indice) % campanhas.length];
  if (reservaPct >= 100) return campanhas.map((_, indice) => campanhaDaRodada(indice));

  const quantidade = Math.max(1, Math.round((proprias.length * reservaPct) / (100 - reservaPct)));
  const passo = Math.ceil(proprias.length / quantidade);
  const lista: Midia[] = [];
  let usadas = 0;

  proprias.forEach((midia, indice) => {
    lista.push(midia);
    if ((indice + 1) % passo === 0 && usadas < quantidade) lista.push(campanhaDaRodada(usadas++));
  });
  while (usadas < quantidade) lista.push(campanhaDaRodada(usadas++));
  return lista;
}

/** Mesmo intervalo da proporção do bar: 100/pct minutos; zero nunca abre. */
export function intervaloBarraMs(pct: number): number {
  return pct > 0 ? Math.round((100 / pct) * 60_000) : 0;
}
